<template>
    <div class="sectionx">
        <br />
        <form>
            <div class="row">
                <div class="col s12 m7">
                    <!-- <div class="card-panel"> -->
                    <FilterDiv inputId="filterClient" :data="filterClientData" :startAgain="resetClient"
                        @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
                    <!-- </div> -->
                </div>

                <div class="col s12 m5">
                    <!-- <div class="card-panel"> -->
                    <FilterDiv inputId="filterDuration" :data="filterDurationData" :startAgain="resetDuration"
                        @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
                    <!-- </div> -->
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <!-- <div class="card-panel"> -->
                    <FilterDiv inputId="filterEnrollee" :data="filterEnrolleeData" :startAgain="resetEnrollee"
                        @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
                    <!-- </div> -->
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { computed, onMounted, ref, watchEffect } from "vue";
import getItems from "@/composables/getItems";
import FilterDiv from "@/components/search/FilterDiv.vue";
import { searchMonths } from "@/composables/fxLibrary/months";
import { normalizeEnrolleeSearchValue } from "@/composables/enrolleeNumber";

export default {
    name: "FilterEnrolleeComponent",
    components: { FilterDiv },
    emits: ["search"],
    setup(props, context) {
        const responseSearch = ref(null);
        const responseDurationDefault = ref(null);
        const resetEnrollee = ref(null);
        const resetClient = ref(null);
        const resetDuration = ref(null);
        const searchBody = ref([]);
        const selectedItem = ref(null);
        const selectedEnrollee = ref("");
        const selectedClient = ref("");
        const selectedDuration = ref("");
        const specialCase = ref([]);

        // special
        // config
        const providerId = 165;

        // enrollee data
        const filterEnrolleeData = computed(() => {
            // start
            let val = {
                "All Enrollees": null,
            };

            let valPlus;
            let valPlusPlus;

            if (responseSearch.value) {
                if (responseSearch.value.key == "filterEnrollee") {
                    valPlus = responseSearch.value.value.reduce((newArr, x) => {
                        newArr[x.name] = null;
                        return newArr;
                    }, {});
                    valPlusPlus = responseSearch.value.value.reduce((newArr, x) => {
                        newArr[x.enrollee_number] = null;
                        return newArr;
                    }, {});
                    val = { ...val, ...valPlus, ...valPlusPlus };
                }
            }

            // return final
            return val;
        });

        // Duration
        const filterDurationData = computed(() => {
            // start
            let val = {}; // load on fly

            let valPlus;

            if (responseDurationDefault.value) {
                if (responseDurationDefault.value.key == "filterDuration") {
                    valPlus = responseDurationDefault.value.value.reduce((newArr, x) => {
                        newArr[x.period] = null;
                        return newArr;
                    }, {});
                    val = { ...val, ...valPlus };
                }
            }

            // return final
            return val;
        });

        // duration data
        const filterClientData = computed(() => {
            // start
            let val = {
                "All Clients": null,
            };

            let valPlus;

            if (responseSearch.value) {
                if (responseSearch.value.key == "filterClient") {
                    valPlus = responseSearch.value.value.reduce((newArr, x) => {
                        newArr[x.client_name] = null;
                        return newArr;
                    }, {});
                    val = { ...val, ...valPlus };
                }
            }

            // return final
            return val;
        });

        // search function
        const getSearchItemsFromApi = (table, key) => {
            (async () => {
                const { res } = await getItems(table);
                if (res.value) {
                    // search
                    responseSearch.value = { key: key, value: res.value.data };
                }
            })();
        };

        // filter (Initialize)
        onMounted(() => {
            // initialize filterDuration
            const { fx } = searchMonths(true); // true for next month

            /*
           Special defualt cases
           */
            specialCase.value.push({ ...fx.value[1], key: "filterDuration" }); // current month

            // set
            responseDurationDefault.value = {
                key: "filterDuration",
                value: fx.value,
            };

            /*
           Set reset (search special array, 
           in case there are other special cases)
           */
            specialCase.value.forEach((x) => {
                if (x.key == "filterDuration") {
                    // filter display
                    resetDuration.value = x.period;
                    // search results
                    searchBody.value.push(`Period (${x.period})`);
                    // search params
                    selectedDuration.value = x.date; // load directly
                    // trigger search
                    selectedItem.value = { id: x.key, value: x.period, special: true };
                }
            });
        });

        // enrollee, provider & client filter
        const handleSearch = (val) => {
            if (val.id == "filterEnrollee") {
                // get new serach items
                getSearchItemsFromApi(`enrollee/filter?q=${val.value}`, val.id);
            } else if (val.id == "filterClient") {
                // get new serach items
                getSearchItemsFromApi(`enrollee/filter/client?q=${val.value}`, val.id);
            } else if (val.id == "filterDuration") {
                // preset
            }
        };

        // clear (null reset)
        const handleClear = (val) => {
            if (val.id == "filterEnrollee") {
                resetEnrollee.value = val.value;
            } else if (val.id == "filterClient") {
                resetClient.value = val.value;
            } else if (val.id == "filterDuration") {
                resetDuration.value = val.value;
            }
        };

        // selected item
        const handlePick = (val) => {
            selectedItem.value = val;
            // watchEffect will take over from here
        };

        // route composer
        watchEffect(() => {
            // token
            let searchToken = false;

            // start
            if (selectedItem.value) {
                // sort
                if (selectedItem.value.id == "filterPass") {
                    // set token
                    searchToken = true;

                } if (selectedItem.value.id == "filterEnrollee") {
                    // set token
                    searchToken = true;

                    //set
                    if (
                        Object.keys(filterEnrolleeData.value)[0] == selectedItem.value.value
                    ) {
                        selectedEnrollee.value = "";
                        searchBody.value = searchBody.value.filter(
                            (x) => !x.includes("Enrollee")
                        );
                    } else {
                        // update search body
                        searchBody.value = searchBody.value.filter(
                            (x) => !x.includes("Enrollee")
                        );
                        searchBody.value = searchBody.value.filter(
                            (x) => !x.includes("Client")
                        );
                        searchBody.value.push(`Enrollee (${selectedItem.value.value})`);
                        // get enrollee number from name or enrollee_number (self)
                        // responseSearch will have all the complete data
                        responseSearch.value.value.forEach((x) => {
                            if (x.name == selectedItem.value.value) {
                                // found
                                selectedEnrollee.value = x.enrollee_number;
                            }
                            if (normalizeEnrolleeSearchValue(x.enrollee_number) == normalizeEnrolleeSearchValue(selectedItem.value.value)) {
                                // found
                                selectedEnrollee.value = x.enrollee_number;
                            }
                        });
                        if (selectedEnrollee.value) {
                            // reset search fields (for better search results)
                            resetClient.value = Object.keys(filterClientData.value)[0];
                            // clear corresponding search
                            selectedClient.value = "";
                        }
                    }

                } else if (selectedItem.value.id == "filterClient") {
                    // set token
                    searchToken = true;

                    //set
                    if (
                        Object.keys(filterClientData.value)[0] == selectedItem.value.value
                    ) {
                        selectedClient.value = "";
                        searchBody.value = searchBody.value.filter((x) => !x.includes("Client"));
                    } else {
                        // update search body
                        searchBody.value = searchBody.value.filter((x) => !x.includes("Client"));
                        searchBody.value = searchBody.value.filter(
                            (x) => !x.includes("Enrollee")
                        );
                        searchBody.value.push(`Client (${selectedItem.value.value})`);
                        // get client
                        // responseSearch will have all the complete data
                        responseSearch.value.value.forEach((x) => {
                            if (x.client_name == selectedItem.value.value) {
                                // found
                                selectedClient.value = x.client_name;
                            }
                        });
                        if (selectedClient.value) {
                            // reset search fields (for better search results)
                            resetEnrollee.value = Object.keys(filterEnrolleeData.value)[0];
                            // clear corresponding search
                            selectedEnrollee.value = "";
                        }
                    }
                } else if (selectedItem.value.id == "filterDuration") {
                    // set token
                    searchToken = true;
                    // check default
                    if (selectedItem.value.special) {
                        specialCase.value.forEach((x) => {
                            if (x.key == "filterDuration") {
                                resetDuration.value = x.period;
                                selectedItem.value.value = x.period;
                            }
                        });
                    }

                    // update search body
                    searchBody.value = searchBody.value.filter(
                        (x) => !x.includes("Period")
                    );
                    searchBody.value = searchBody.value.filter(
                        (x) => !x.includes("Enrollee") && !x.includes("Client")
                    );
                    searchBody.value.push(`Period (${selectedItem.value.value})`);

                    // get duration day
                    // responseDurationDefault will have all the complete data
                    responseDurationDefault.value.value.forEach((x) => {
                        if (x.period == selectedItem.value.value) {
                            // found
                            selectedDuration.value = x.date;
                        }
                    });
                    if (selectedDuration.value) {
                        // reset search fields (for better search results)
                        resetEnrollee.value = Object.keys(filterEnrolleeData.value)[0];
                        resetClient.value = Object.keys(filterClientData.value)[0];
                        // clear corresponding search
                        selectedEnrollee.value = "";
                        selectedClient.value = "";
                    }
                }

                if (searchToken) {
                    // start laoding
                    let searchTitle = null;
                    let currUrl = null;
                    let currHook = null;

                    // label
                    if (
                        selectedEnrollee.value ||
                        selectedClient.value ||
                        selectedDuration.value
                    ) {
                        let uniqueBody = [...new Set(searchBody.value)];
                        searchTitle = `<span class="black blue-text chip">Search <i class="tiny material-icons">check_circle</i></span>`;
                        uniqueBody.forEach((x) => {
                            searchTitle += `<span class="yellow lighten-2 black-text chip"><em>${x}</em></span> `;
                        });
                        searchTitle = searchTitle.slice(0, -2);
                    } else {
                        searchTitle = null;
                    }


                    /* 
                    Check url (accessController)
                    Update Curr Scheme from User
                    */

                    // set current Url
                    currUrl = `enrollee/list/search?p=${providerId}&e=${encodeURIComponent(normalizeEnrolleeSearchValue(selectedEnrollee.value))}&c=${selectedClient.value}&d=${selectedDuration.value}`;
                    // set current Hook
                    currHook = "&";

                    // emit new parameters
                    context.emit("search", {
                        searchTitle: searchTitle,
                        listMonth: selectedDuration.value,
                        currUrl: currUrl,
                        currHook: currHook,
                    });


                    // kill token
                    searchToken = false;
                    // kill searchItem
                    selectedItem.value = null;
                }
            }
        });

        return {
            handleSearch,
            handleClear,
            handlePick,
            selectedItem,
            resetEnrollee,
            resetClient,
            resetDuration,
            filterEnrolleeData,
            filterDurationData,
            filterClientData,
            selectedEnrollee,
            selectedDuration,
            selectedClient,
        };
    },
};
</script>

<style></style>
